"use client";

/**
 * About: layout theo FullWidth (gap 33 / 1120), ảnh + ornament theo design (viền nét đứt + lưới chấm).
 */
export interface SectionWrapperDathaconsProps {
  sectionId?: string;
  overline: string;
  heading: string;
  paragraphs: string[];
  /** URL hoặc path ảnh (vd. asset Figma hoặc /dathacons/...) */
  imageSrc: string;
  imageAlt?: string;
}

export default function SectionWrapperDathacons({
  sectionId = "about",
  overline,
  heading,
  paragraphs,
  imageSrc,
  imageAlt = "",
}: SectionWrapperDathaconsProps) {
  return (
    <div
      id={sectionId}
      className="content-stretch flex items-start justify-center relative z-[2] shrink-0 w-full max-md:py-10 md:pt-4 md:pb-14"
      data-name="About section"
    >
      <div
        className="content-stretch flex flex-col gap-8 items-center max-md:w-full md:flex-row md:gap-[33px] relative shrink-0 w-[1120px] max-w-[min(1120px,calc(100%-20px))]"
        data-name="Container max-width 1120px About section content"
      >
        <div
          className="aspect-[911/631] flex-[1_0_0] min-h-px min-w-px relative w-full md:w-auto"
          data-name="About image"
        >
          {/* L-shape dashed top + left — offset ngoài góc ảnh */}
          <div
            className="pointer-events-none absolute -left-3 -top-3 z-0 h-[72%] w-[78%] border-l-2 border-t-2 border-dashed border-[#ffa411] md:-left-4 md:-top-4"
            aria-hidden
          />
          {/* Lưới chấm góc dưới-phải, phía sau ảnh */}
          <div
            className="pointer-events-none absolute -bottom-3 -right-2 z-0 h-32 w-40 opacity-[0.45] md:-bottom-4 md:h-40 md:w-48"
            style={{
              backgroundImage: "radial-gradient(circle, #94a3b8 1.1px, transparent 1.1px)",
              backgroundSize: "9px 9px",
            }}
            aria-hidden
          />
          <img
            alt={imageAlt}
            className="absolute inset-0 z-10 max-w-none object-cover pointer-events-none size-full shadow-sm"
            src={imageSrc}
            loading="lazy"
            decoding="async"
          />
        </div>

        <div
          className="content-stretch flex flex-[1_0_0] flex-col gap-[16px] items-start min-h-px min-w-px not-italic relative"
          data-name="About details"
        >
          <div
            className="content-stretch flex flex-col gap-[6px] items-start relative shrink-0 w-full"
            data-name="Section title container"
          >
            <p className="font-semibold leading-[normal] relative shrink-0 text-[#ffa411] text-[20px] w-full">
              {overline}
            </p>
            <p className="font-extrabold leading-[60px] relative shrink-0 text-[#e07800] text-[47px] w-full max-md:text-[35px] max-md:leading-[1.2]">
              {heading}
            </p>
          </div>
          {paragraphs.map((p, i) => (
            <p
              key={i}
              className="font-normal leading-[26px] relative shrink-0 text-[#303030] text-[17px] w-full"
            >
              {p}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

SectionWrapperDathacons.displayName = "SectionWrapperDathacons";
